import { IInitAction } from './init'

// Action types
export enum types {
  GET_PUBLISHING_LOCATIONS__STARTED = 'GET_PUBLISHING_LOCATIONS__STARTED',
  GET_PUBLISHING_LOCATIONS__SUCCESS = 'GET_PUBLISHING_LOCATIONS__SUCCESS',
  GET_PUBLISHING_LOCATIONS__FAILURE = 'GET_PUBLISHING_LOCATIONS__FAILURE',
}

export interface IGetPublishingLocationsAction {
  type: types.GET_PUBLISHING_LOCATIONS__STARTED
}

export interface IGetPublishingLocationsSuccessAction {
  type: types.GET_PUBLISHING_LOCATIONS__SUCCESS
  list: IPublishingLocation[]
}

export interface IFailureAction {
  type: types.GET_PUBLISHING_LOCATIONS__FAILURE
  message: string
}

export type PublishingLocationsActionType =
  | IGetPublishingLocationsAction
  | IGetPublishingLocationsSuccessAction
  | IFailureAction
  | IInitAction

// Reducer types
export interface IPublishingLocation {
  name: string
  title: string
  description: string
}

export interface IPublishingLocations {
  isLoading: boolean
  list: IPublishingLocation[]
  message?: string
}
